import React, { Component } from 'react';

class HuntDistance extends Component {

  componentDidMount() {
    document.title = 'Flamingo Scooters';
  }

  render() {
    return (
      <div className="hunt-redeemed">
        <div className="hunt-redeemed-box">
          <p className="hunt-redeemed-try">TRY</p>
          <p className="hunt-redeemed-again">AGAIN!</p>
        </div>
        <p className="hunt-redeemed-note">You don't seem to be close enough to the poster.</p>
        <p className="download-note">Make sure Location Services are turned on and you are in front of the physical poster.</p>
        <p className="hunt-redeemed-footer">Flamingo Egg Hunt 2021</p>
      </div>
    );
  }
}

export default HuntDistance;
